<template>
  <div>
    <BaseModal
      :value="showForm"
      @close="showForm = false"
      title="Search Person"
      id="infoauto-person-selector"
      :loading="loading"
      @input="showForm = false"
    >
      <div class="content-infoauto p-4 pt-10 flex flex-col relative">
        <BaseSpinner v-if="loading" class="spinner" />
        <h1>Search for a person</h1>
        <input
          type="text"
          v-model="search"
          ref="search"
          id="search"
          placeholder="search"
          class="border mt-4 border-gray-300 rounded-md w-full p-2 mb-4"
        />
        <hr />
        <div id="results" class="flex-grow">
          <div
            v-for="person in results"
            :key="person.id"
            @click="selectPerson(person)"
            class="cursor-pointer border border-gray-300 rounded-md w-full p-2 mb-4"
          >
            <p>{{ person.nombreComp }}</p>
            <p>{{ person.email1 }}</p>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      :value="selectedPerson"
      @close="selectedPerson = null"
      title="Select address"
      id="infoauto-address-selector"
    >
      <div class="content-infoauto p-4 pt-10 flex flex-col relative">
        <BaseSpinner v-if="loading" class="spinner" />
        <h1>Select Address</h1>
        <hr />
        <div
          v-for="address in addressOptions"
          :key="address.id"
          @click="selectAddress(address)"
          class="cursor-pointer border border-gray-300 rounded-md w-full p-2 mb-4"
        >
          <h1>
            {{
              `
        ${address.calleCasa},
        ${address.ciudad},
        ${address.codEstado},
        ${address.codPostal} ${address.codPais}
      `
            }}
          </h1>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      v-if="showPhoneSelector"
      :value="showPhoneSelector && personInfoautoData"
      @close="showPhoneSelector = false"
      title="Select phone"
      id="infoauto-phone-selector"
    >
      <div class="content-infoauto p-4 pt-10 flex flex-col relative">
        <BaseSpinner v-if="loading" class="spinner" />
        <h1>Select Phone</h1>
        <hr />
        <div
          v-for="phone in personInfoautoData.telefono"
          :key="phone.telefonoId"
          @click="selectPhone(phone)"
          class="cursor-pointer border border-gray-300 rounded-md w-full p-2 mb-4"
        >
          <h1>{{ phone.codArea }}-{{ phone.numero }}</h1>
        </div>
      </div>
    </BaseModal>
    <button @click="showInfoautoSearch" v-if="!currentPersonId">
      Select from infoauto
    </button>
    <div v-else>
      <p>
        <b>{{ name }}</b>
      </p>
      <p>{{ email }}</p>
      <p v-if="phone">Phone: {{ phone }}</p>
      <p v-if="address">{{ address }}</p>
      <button class="text-red-500" @click="$emit('selected', null)">
        Remove person
      </button>
    </div>
  </div>
</template>
<script>
import { searchPersonInfoauto, getPersonAdressList } from "@/api/Infoauto.js";
export default {
  name: "BaseInfoautoPersonSelector",
  data() {
    return {
      selectedPerson: null,
      selectedAddress: null,
      personInfoautoData: null,
      search: "",
      showForm: false,
      showPhoneSelector: false,
      loading: false,
      results: [],
      addressOptions: []
    };
  },
  props: {
    currentPersonId: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    phone: {
      type: String,
      required: false
    },
    email: {
      type: String,
      required: false
    },
    address: {
      type: String,
      required: false
    }
  },
  watch: {
    search() {
      if (!this.showForm) {
        return;
      }
      this.searchPerson();
    }
  },
  methods: {
    selectPhone(phone) {
      const address = `${this.selectedAddress.calleCasa}, ${this.selectedAddress.ciudad}, ${this.selectedAddress.codEstado}, ${this.selectedAddress.codPostal}, ${this.selectedAddress.codPais}`;
      this.$emit("selected", {
        name: this.selectedPerson.nombreComp,
        email: this.selectedPerson.email1,
        phone: `${phone.codArea}-${phone.numero}`,
        personId: this.selectedPerson.personaId,
        address
      });
      this.showPhoneSelector = false;
      this.reset();
    },
    reset() {
      this.selectedPerson = null;
      this.selectedAddress = null;
      this.personInfoautoData = null;
      this.search = "";
      this.results = [];
      this.addressOptions = [];
      this.showForm = false;
    },
    selectPerson(person) {
      this.selectedPerson = person;
      this.loadAddressOptions();
    },
    selectAddress(address) {
      this.selectedAddress = address;
      this.showPhoneSelector = true;
    },
    loadAddressOptions() {
      this.loading = true;
      getPersonAdressList(this.selectedPerson.personaId)
        .then(results => {
          this.personInfoautoData = results;
          this.addressOptions = results.direccion;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchPerson() {
      this.loading = true;
      searchPersonInfoauto(this.search)
        .then(results => {
          this.loading = false;
          this.showForm = true;
          this.results = results.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showInfoautoSearch() {
      this.showForm = true;
      setTimeout(() => {
        this.$nextTick(() => {
          const input = document.getElementById("search");
          console.log(input);
          if (input) {
            console.log("focus");
            input.focus();
          }
        });
      }, 100);
    }
  }
};
</script>
<style lang="scss">
#infoauto-person-selector,
#infoauto-address-selector,
#infoauto-phone-selector {
  .modal-content {
    width: 400px;
    max-height: 800px;
    margin-top: calc(50vh - 400px);
  }
}
.content-infoauto {
  display: flex;
  flex-direction: column;
  max-height: 800px;
}
#results {
  overflow-y: auto;
  height: 100%;
}
.spinner {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
}
</style>
